module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.75de32d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/AmwayIcons.ttf?5v2gxx
// module id = qwf+
// module chunks = 0